import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { useDateTimePicker } from 'components/hooks/useDatePicker';
import { StyledButton, StyledTooltip } from 'styles/common';

import { ONE_ON_ONE_STATUSES } from 'constants/ProjectConstants';
import { convertDateToString11, convertDateToString7 } from 'constants/helper';
import theme from 'constants/theme';

export const BottomPanel = ({
  enableMarkAsComplete,
  status,
  editorName,
  lastUpdatedTime,
  onDateTimeChange,
  startDateTime,
  endDateTime,
  toggleCancelMeetingModal,
  handleMarkAsComplete,
  canMarkAsComplete,
  isLoading = false,
}) => {
  const openDateTimePicker = useDateTimePicker(onDateTimeChange);
  if (status === ONE_ON_ONE_STATUSES.ACKNOWLEDGED || status === ONE_ON_ONE_STATUSES.CANCELLED) {
    return (
      <Grid
        style={{ marginBottom: '2rem' }}
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <Typography variant="body2" style={{ color: theme.palette.text.secondary, paddingLeft: '1rem' }}>
            {`This meeting was ${status === ONE_ON_ONE_STATUSES.ACKNOWLEDGED ? 'completed' : 'cancelled'}`}
            {editorName && lastUpdatedTime ? ` by ${editorName} on ${lastUpdatedTime}.` : `.`}
          </Typography>
        </Grid>

        <Grid item>
          <Grid item>
            <StyledButton
              fullWidth
              variant="contained"
              customColor={theme.palette.primary.main}
              fontColor="white"
              // onClick={() => {}}
              disabled
              disableElevation
            >
              {status === ONE_ON_ONE_STATUSES.ACKNOWLEDGED ? 'Completed' : 'Cancelled'}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid style={{ marginBottom: '2rem' }} container direction="row" justifyContent="space-between">
      <Grid item>
        <StyledButton
          fullWidth
          variant="contained"
          customColor="transparent"
          fontColor="black"
          onClick={toggleCancelMeetingModal}
          disabled={false}
          disableElevation
        >
          Cancel this Meeting
        </StyledButton>
      </Grid>

      <Grid item>
        <Grid container direction="row" style={{ columnGap: 15 }}>
          <Grid item>
            <StyledButton
              fullWidth
              variant="outlined"
              customColor={theme.palette.background.paper}
              style={{ borderColor: theme.palette.primary.main }}
              fontColor={theme.palette.primary.main}
              onClick={() =>
                openDateTimePicker({
                  initialDate: startDateTime,
                  endDate: endDateTime,
                  openTo: 'hours',
                  isOneOnOneDatePicker: true,
                })
              }
              disabled={false}
              disableElevation
            >
              Reschedule
            </StyledButton>
          </Grid>
          <Grid item>
            {canMarkAsComplete ? (
              <StyledButton
                fullWidth
                variant="contained"
                customColor={theme.palette.primary.main}
                fontColor="white"
                onClick={handleMarkAsComplete}
                disabled={isLoading}
                disableElevation
              >
                Mark as Complete
              </StyledButton>
            ) : (
              <StyledTooltip
                title={`You can mark this meeting as complete after ${convertDateToString11(
                  startDateTime
                )}  at ${convertDateToString7(startDateTime, true)}`}
              >
                <StyledButton
                  fullWidth
                  variant="contained"
                  customColor={theme.palette.primary.main}
                  fontColor="white"
                  onClick={handleMarkAsComplete}
                  disabled
                  disableElevation
                >
                  Mark as Complete
                </StyledButton>
              </StyledTooltip>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
